define("shared/components/shared/post/secondary/publishing-method-setup/no-publish-method/index", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Post::Secondary::PublishingMethodSetup::Layout @title={{t "onboarding.side_wiz.general.title"}}>
    <:body>
      {{#if this.recommendAutoPublish}}
        <p>
          {{t "onboarding.side_wiz.general.subcopy.business_profile" username=@socialProfile.displayNickname}}
        </p>
        {{#if @isMultiProfilePost}}
          <div class="u--m__tb">
            <Shared::Ui::Button @onClick={{@back}} @variant="actionLink">
              {{svg-jar "arrow-left" class="o--icon u--m__r__xs"}}
              {{t "shared_words.back"}}
            </Shared::Ui::Button>
          </div>
        {{/if}}
        <Shared::Post::Secondary::PublishingMethodSetup::Setup::AutoPublish
          @isMultiProfilePost={{@isMultiProfilePost}}
          @post={{@post}}
          @recommended={{true}}
          @setPublishingSetupComponent={{@setPublishingSetupComponent}}
          @socialProfile={{@socialProfile}}
        />
        <Shared::Post::Secondary::PublishingMethodSetup::Setup::NotificationPublish
          @setPublishingSetupComponent={{@setPublishingSetupComponent}}
        />
      {{else}}
        <p>
          {{t
            (if
              @socialProfile.isCreator
              "onboarding.side_wiz.general.subcopy.creator_profile"
              "onboarding.side_wiz.general.subcopy.personal_profile"
            )
            username=@socialProfile.displayNickname
          }}
        </p>
        {{#if @isMultiProfilePost}}
          <div class="u--m__tb">
            <Shared::Ui::Button @onClick={{@back}} @variant="actionLink">
              {{svg-jar "arrow-left" class="o--icon u--m__r__xs"}}
              {{t "shared_words.back"}}
            </Shared::Ui::Button>
          </div>
        {{/if}}
        <Shared::Post::Secondary::PublishingMethodSetup::Setup::NotificationPublish
          @recommended={{true}}
          @setPublishingSetupComponent={{@setPublishingSetupComponent}}
        />
        <Shared::Post::Secondary::PublishingMethodSetup::Setup::AutoPublish
          @isMultiProfilePost={{@isMultiProfilePost}}
          @post={{@post}}
          @setPublishingSetupComponent={{@setPublishingSetupComponent}}
          @socialProfile={{@socialProfile}}
        />
      {{/if}}
    </:body>
  </Shared::Post::Secondary::PublishingMethodSetup::Layout>
  */
  {
    "id": "YE2golpO",
    "block": "[[[8,[39,0],null,[[\"@title\"],[[28,[37,1],[\"onboarding.side_wiz.general.title\"],null]]],[[\"body\"],[[[[1,\"\\n\"],[41,[30,0,[\"recommendAutoPublish\"]],[[[1,\"      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"onboarding.side_wiz.general.subcopy.business_profile\"],[[\"username\"],[[30,1,[\"displayNickname\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"        \"],[10,0],[14,0,\"u--m__tb\"],[12],[1,\"\\n          \"],[8,[39,3],null,[[\"@onClick\",\"@variant\"],[[30,3],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,4],[\"arrow-left\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_words.back\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[8,[39,5],null,[[\"@isMultiProfilePost\",\"@post\",\"@recommended\",\"@setPublishingSetupComponent\",\"@socialProfile\"],[[30,2],[30,4],true,[30,5],[30,1]]],null],[1,\"\\n      \"],[8,[39,6],null,[[\"@setPublishingSetupComponent\"],[[30,5]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[[52,[30,1,[\"isCreator\"]],\"onboarding.side_wiz.general.subcopy.creator_profile\",\"onboarding.side_wiz.general.subcopy.personal_profile\"]],[[\"username\"],[[30,1,[\"displayNickname\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"        \"],[10,0],[14,0,\"u--m__tb\"],[12],[1,\"\\n          \"],[8,[39,3],null,[[\"@onClick\",\"@variant\"],[[30,3],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,4],[\"arrow-left\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_words.back\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[8,[39,6],null,[[\"@recommended\",\"@setPublishingSetupComponent\"],[true,[30,5]]],null],[1,\"\\n      \"],[8,[39,5],null,[[\"@isMultiProfilePost\",\"@post\",\"@setPublishingSetupComponent\",\"@socialProfile\"],[[30,2],[30,4],[30,5],[30,1]]],null],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]]],[\"@socialProfile\",\"@isMultiProfilePost\",\"@back\",\"@post\",\"@setPublishingSetupComponent\"],false,[\"shared/post/secondary/publishing-method-setup/layout\",\"t\",\"if\",\"shared/ui/button\",\"svg-jar\",\"shared/post/secondary/publishing-method-setup/setup/auto-publish\",\"shared/post/secondary/publishing-method-setup/setup/notification-publish\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/no-publish-method/index.hbs",
    "isStrictMode": false
  });

  class NoPublishMethodComponent extends _component2.default {
    get socialProfile() {
      return this.args.socialProfile;
    }

    get recommendAutoPublish() {
      return this.socialProfile.get('isBusiness') && (this.socialProfile.get('isInstagram') || this.socialProfile.get('isTiktok'));
    }

  }

  _exports.default = NoPublishMethodComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NoPublishMethodComponent);
});